export default __webpack_public_path__ + "static/media/elefantes-coracao.8e8b6bcd.png";